import { Controller } from "@hotwired/stimulus"

// Filter chips (All / Completed / Failed) + free-text search for the
// `/insights` history timeline. Operates entirely client-side — toggles
// rows + day-bucket headers by setting the `hidden` class. No fetch,
// no debounce, no escape — list cap is ~50 rows.
export default class extends Controller {
  static targets = ["row", "bucket", "chip", "search", "empty"]

  connect() {
    console.log(`[history-filter] connect rows=${this.rowTargets.length} buckets=${this.bucketTargets.length} chips=${this.chipTargets.length}`)
    this.status = "all"
    this.query  = ""
  }

  chooseStatus(event) {
    const chip = event.currentTarget
    this.status = chip.dataset.status || "all"
    // Set the active chip to data-active="true" (not a bare boolean attribute):
    // the chip styling keys off `data-[active=true]` → CSS [data-active=true],
    // which toggleAttribute's empty value would never match.
    this.chipTargets.forEach((c) => {
      if (c === chip) {
        c.setAttribute("data-active", "true")
      } else {
        c.removeAttribute("data-active")
      }
    })
    this.applyFilters()
  }

  search(event) {
    this.query = (event.target.value || "").trim().toLowerCase()
    this.applyFilters()
  }

  applyFilters() {
    let visibleCount = 0
    this.rowTargets.forEach((row) => {
      const matchesStatus = this.status === "all" || row.dataset.status === this.status
      const matchesQuery  = this.query === ""    || (row.dataset.search || "").includes(this.query)
      const visible = matchesStatus && matchesQuery
      row.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    // Hide day-bucket containers whose rows are all filtered out.
    this.bucketTargets.forEach((bucket) => {
      const anyVisible = bucket.querySelectorAll("[data-history-filter-target='row']:not(.hidden)").length > 0
      bucket.classList.toggle("hidden", !anyVisible)
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }
}
